import { render, staticRenderFns } from "./ModalPendenciasHomologacao.vue?vue&type=template&id=26a334f5"
import script from "./ModalPendenciasHomologacao.vue?vue&type=script&lang=ts"
export * from "./ModalPendenciasHomologacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports